import { FlowLayout } from 'Layouts/FlowLayout'
import { HomeLayout } from 'Layouts/HomeLayout'
import { HomeLayoutPage } from 'Layouts/HomeLayout/Page'
import OrganisationLayout from 'Layouts/OrganisationLayout'
import SettingsPageLayout from 'Pages/Engage/Settings'
import IpRestricted from 'Pages/Organisation/IpRestricted'
import { Button, Result } from 'antd'
import { Link, createBrowserRouter } from 'react-router-dom'

/*
lazy component will support exports having name Component
=> Alertnatively we can use this approach
async lazy() {
  let { AuthLayout } = await import('Layouts/AuthLayout')
  return { Component: AuthLayout }
}

=> To pass props use loader property and useLoader in component to read 
 */

const routes = createBrowserRouter([
  {
    path: '/login',
    lazy: () => import('../NewLogin'),
  },
  {
    path: '/',
    lazy: () => import('Layouts/AuthLayout'),
    children: [
      {
        Component: HomeLayout,
        children: [
          {
            index: true,
            lazy: () => import('../Organisation'),
          },
          {
            path: 'templates',
            lazy: () => import('Pages/Home/Templates/GlobalTemplatesPage'),
          },
        ],
      },
      {
        Component: HomeLayout,
        path: 'apigateway-admin',
        children: [
          {
            index: true,
            lazy: () => import('Pages/ApigatewayAdmin/index'),
          },
          {
            path: 'users',
            lazy: () => import('Pages/ApigatewayAdmin/index'),
          },
          {
            path: 'users/:user_uuid',
            lazy: () => import('Pages/ApigatewayAdmin/Users/:user_uuid'),
          },
          {
            path: 'permission-policies',
            lazy: () => import('Pages/ApigatewayAdmin/index'),
          },
          {
            path: 'roles',
            lazy: () => import('Pages/ApigatewayAdmin/index'),
          },
          {
            path: 'scopes',
            lazy: () => import('Pages/ApigatewayAdmin/index'),
          },
          {
            path: 'apis',
            lazy: () => import('Pages/ApigatewayAdmin/index'),
          },
        ],
      },
      {
        path: 'clients',
        children: [
          {
            Component: HomeLayout,
            children: [
              {
                index: true,
                lazy: () => import('../Organisation'),
              },
            ],
          },
          {
            path: ':organisation_uuid',
            children: [
              {
                Component: OrganisationLayout,
                children: [
                  {
                    index: true,
                    lazy: () => import('Pages/Home/VoiceAgentsPage'),
                  },
                ],
              },
              {
                path: 'voice-agents',
                children: [
                  {
                    Component: OrganisationLayout,
                    children: [
                      {
                        index: true,
                        lazy: () => import('Pages/Home/VoiceAgentsPage'),
                      },
                    ],
                  },
                  {
                    Component: FlowLayout,
                    path: ':flow_uuid',
                    children: [
                      {
                        index: true,
                        lazy: () => import('Pages/Flows/Build'),
                      },
                      {
                        path: ':flow_version',
                        children: [
                          {
                            index: true,
                            lazy: () => import('Pages/Flows/Build'),
                          },
                          {
                            path: 'design',
                            lazy: () => import('Pages/Flows/Build'),
                          },
                          {
                            path: 'design/:sub_flow',
                            lazy: () => import('Pages/Flows/Build'),
                          },
                          {
                            path: 'configure',
                            lazy: () => import('Pages/Flows/Configure'),
                          },
                          {
                            path: 'configure/:configure_tab',
                            lazy: () => import('Pages/Flows/Configure'),
                          },
                          {
                            path: 'configure/:configure_tab/:configure_sub_tab',
                            lazy: () => import('Pages/Flows/Configure'),
                          },
                        ],
                      },
                      {
                        path: 'train',
                        lazy: () => import('Pages/Train'),
                      },
                      {
                        path: 'train/:train_tab',
                        lazy: () => import('Pages/Train'),
                      },
                      // @e2e-experimental-testing
                      {
                        path: 'test',
                        lazy: () => import('../Flows/Test'),
                      },
                      {
                        path: 'test/:test_tab',
                        lazy: () => import('../Flows/Test'),
                      },
                      {
                        path: 'deploy',
                        lazy: () => import('Pages/Deploy'),
                      },
                      {
                        path: 'analytics',
                        lazy: () => import('Pages/Flows/Dashboard'),
                      },
                      {
                        path: 'analytics/:analytics_tab',
                        lazy: () => import('Pages/Flows/Dashboard'),
                      },
                      {
                        path: 'calls',
                        lazy: () => import('Pages/Flows/Calls/CallsPage'),
                      },
                      {
                        path: 'calls/:call_uuid',
                        lazy: () => import('Pages/Flows/Calls/DetailedCallPage'),
                      },

                      {
                        path: 'campaign_manager',
                        children: [
                          {
                            index: true,
                            lazy: () => import('Pages/CampaignManager/CampaignsList'),
                          },
                          {
                            path: ':campaign_uuid',
                            lazy: () => import('Pages/CampaignManager/Configure'),
                          },
                          {
                            path: ':campaign_id/:configure_tab',
                            lazy: () => import('Pages/CampaignManager/Configure'),
                          },
                        ],
                      },
                      {
                        path: 'tcn_campaigns',
                        lazy: () => import('Pages/Flows/TCNCampaigns'),
                      },

                      {
                        path: 'documentation',
                        lazy: () => import('Pages/Flows/Documentation'),
                      },

                      {
                        path: 'settings',
                        lazy: () => import('Pages/Flows/Settings/GeneralSettingsPage'),
                      },
                    ],
                  },
                  {
                    path: ':flow_uuid/tcn_campaigns/create',
                    children: [
                      {
                        index: true,
                        lazy: () => import('Models/TCNCampaigns/Create'),
                      },
                      {
                        path: ':campaign_type',
                        lazy: () => import('Models/TCNCampaigns/Create'),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'templates',
                children: [
                  {
                    Component: OrganisationLayout,
                    children: [
                      {
                        index: true,
                        lazy: () => import('Pages/Home/Templates/OrganisationTemplatesPage'),
                      },
                    ],
                  },
                  {
                    Component: FlowLayout,
                    path: ':flow_uuid',
                    children: [
                      {
                        index: true,
                        lazy: () => import('Pages/Flows/Build'),
                      },
                      {
                        path: 'train',
                        lazy: () => import('Pages/Train'),
                      },
                      {
                        path: 'train/:train_tab',
                        lazy: () => import('Pages/Train'),
                      },
                      {
                        path: 'test',
                        lazy: () => import('../Flows/Test'),
                      },
                      {
                        path: 'test/:test_tab',
                        lazy: () => import('../Flows/Test'),
                      },
                      {
                        path: 'deploy',
                        lazy: () => import('Pages/Deploy'),
                      },
                      {
                        path: 'analytics',
                        lazy: () => import('Pages/Flows/Dashboard'),
                      },
                      {
                        path: 'analytics/:analytics_tab',
                        lazy: () => import('Pages/Flows/Dashboard'),
                      },
                      {
                        path: 'calls',
                        lazy: () => import('Pages/Flows/Calls/CallsPage'),
                      },
                      {
                        path: 'calls/:call_uuid',
                        lazy: () => import('Pages/Flows/Calls/DetailedCallPage'),
                      },
                      {
                        path: 'tcn_campaigns',
                        lazy: () => import('Pages/Flows/TCNCampaigns'),
                      },
                      {
                        path: 'documentation',
                        lazy: () => import('Pages/Flows/Documentation'),
                      },
                      {
                        path: 'settings',
                        lazy: () => import('Pages/Flows/Settings/GeneralSettingsPage'),
                      },
                      {
                        path: ':flow_version',
                        children: [
                          {
                            index: true,
                            lazy: () => import('Pages/Flows/Build'),
                          },
                          {
                            path: 'design',
                            lazy: () => import('Pages/Flows/Build'),
                          },
                          {
                            path: 'design/:sub_flow',
                            lazy: () => import('Pages/Flows/Build'),
                          },
                          {
                            path: 'configure',
                            lazy: () => import('Pages/Flows/Configure'),
                          },
                          {
                            path: 'configure/:configure_tab',
                            lazy: () => import('Pages/Flows/Configure'),
                          },
                          {
                            path: 'configure/:configure_tab/:configure_sub_tab',
                            lazy: () => import('Pages/Flows/Configure'),
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: 'audit-logs',
                Component: OrganisationLayout,
                children: [
                  {
                    index: true,
                    lazy: () => import('Pages/AuditLogs'),
                  },
                ],
              },
              {
                path: 'settings',
                Component: OrganisationLayout,
                children: [
                  {
                    index: true,
                    lazy: () => import('Pages/Organisation/StudioGeneralSettings'),
                  },
                  {
                    path: 'team/:user_id',
                    lazy: () => import('Pages/ClientSettings/Users'),
                  },
                  {
                    path: ':tab',
                    lazy: () => import('Pages/ClientSettings/index'),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        Component: HomeLayout,
        path: 'engage',
        children: [
          {
            index: true,
            lazy: () => import('Pages/Engage/Audios'),
          },
          {
            path: 'demos',
            lazy: () => import('Pages/Engage/Audios'),
          },
          {
            path: 'interactive',
            lazy: () => import('Pages/Engage/Interactive'),
          },
          {
            path: 'tts',
            lazy: () => import('Pages/Engage/TTS'),
          },
          {
            path: 'settings',
            Component: SettingsPageLayout,
            children: [
              {
                path: 'tags',
                lazy: () => import('Models/Tags/Components/ListTags'),
              },
              {
                path: 'audio-demos',
                lazy: () => import('Models/AudioDemos/Components/ListAudioDemos'),
              },
              {
                path: 'interactive-demos',
                lazy: () => import('Models/InteractiveDemos/Components/ListInteractiveDemos'),
              },
            ],
          },
        ],
      },
      {
        path: 'settings',
        lazy: () => import('Pages/Flows/Settings'),
      },
      {
        path: 'telephony',
        Component: HomeLayout,
        children: [
          {
            path: '',
            Component: HomeLayoutPage,
            children: [
              {
                path: 'clients',
                lazy: () => import('Models/Telephony/Clients/Components/ListClients'),
              },
              {
                path: 'providers',
                lazy: () => import('Models/Telephony/Providers/Components/ListProviders'),
              },
              {
                path: 'blacklist-numbers',
                lazy: () =>
                  import('Models/Telephony/BlacklistNumbers/Components/ListBlacklistNumbers'),
              },
              {
                path: 'workers',
                lazy: () => import('Models/Telephony/Workers/Components/ListWorkers'),
              },
              {
                path: 'concurrency',
                lazy: () => import('Models/Telephony/Concurrency/Components/ListConcurrency'),
              },
            ],
          },
          {
            path: 'virtual-numbers',
            lazy: () => import('Models/Telephony/VirtualNumbers/Components/ListVirtualNumbers'),
          },
        ],
      },
    ],
  },
  {
    path: 'ip-restricted',
    Component: IpRestricted,
  },
  {
    element: (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary">
            <Link to="/">Go Home</Link>
          </Button>
        }
      />
    ),
    path: '*',
  },
])

export default routes

/*
A layout has a custom header and sidebar menu options.
BaseLayout has the current logged in user.

localhost:3000/ -> Redirect to HomeLayout
localhost:3000/home/ -> HomeLayout
localhost:3000/iam/ -> IAMLayout
localhost:3000/flows/ -> Redirect to HomeLayout
localhost:3000/flows/:flow_uuid/* -> Redirect to FlowLayout
*/
